import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { CommonService } from '..'
import { UserContactInfoApiType } from '../lib/common.types'
import {
  CONTACT_INFO_KEY,
  getContactInfoFromStorage,
  setContactInfoToStorage
} from '../lib/contact-info.storage'

export const getContactInfoOptions = () => {
  return queryOptions({
    queryKey: [CONTACT_INFO_KEY],
    queryFn: async (): Promise<UserContactInfoApiType> => {
      try {
        const { data } = await CommonService.getContactInfo()
        setContactInfoToStorage(data)
        return data
      } catch (error) {
        const cachedContactInfo = getContactInfoFromStorage()

        if (cachedContactInfo) {
          return cachedContactInfo
        }

        throw error
      }
    },
    placeholderData: keepPreviousData,
    refetchOnMount: false,
    enabled: true
  })
}

export const useContactInfo = () => {
  const [cachedContactInfo, setCachedContactInfo] = useState<
    UserContactInfoApiType | undefined
  >()

  useEffect(() => {
    setCachedContactInfo(getContactInfoFromStorage())
  }, [])

  const query = useQuery(getContactInfoOptions())
  const data = query.data ?? cachedContactInfo
  const hasContactInfo = Boolean(data?.contactPhone || data?.contactEmail)

  return {
    ...query,
    data,
    hasContactInfo,
    isLoading: query.isLoading && !data,
    isPending: query.isPending && !data
  }
}
